import React from "react";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import { SketchPicker } from "react-color";

class AddColor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showColorPicker: false,
      color: "#aaaaaa"
    };
  }
  handleOpenPicker = () => {
    this.setState({ showColorPicker: !this.state.showColorPicker });
  };

  handleClosePicker = () => {
    this.setState({ showColorPicker: false });
  };

  handleChange = (color, event) => {
    this.setState({ color: color.hex });
  };

  handleSave = async () => {
    const { color } = this.state;

    await this.props
      .createColorMutation({
        variables: { color }
      })
      .then(res => {
        this.props.refetch();
      })
      .catch(e => {
        console.error("add color", e);
      });
    this.setState({
      color: "#aaaaaa"
    });
  };

  render() {
    const popover = {
      position: "relative",
      zIndex: 2,
      bottom: "331px"
    };
    const cover = {
      position: "fixed",
      top: "0px",
      right: "0px",
      bottom: "0px",
      left: "0px"
    };

    return (
      <div>
        <span
          onClick={this.handleOpenPicker}
          className="tag"
          style={{
            backgroundColor: this.state.color,
            cursor: "pointer",
            minWidth: "80px",
            marginTop: "1rem"
          }}
        >
          {this.state.color}
        </span>

        <a onClick={this.handleSave}> ajouter</a>
        {this.state.showColorPicker ? (
          <div style={popover}>
            <div style={cover} onClick={this.handleClosePicker} />
            <SketchPicker
              disableAlpha={true}
              color={this.state.color}
              onChange={this.handleChange}
            />
          </div>
        ) : null}
      </div>
    );
  }
}

const CREATE_COLOR_MUTATION = gql`
  mutation CreateColorMutation($color: String!) {
    createColor(color: $color) {
      id
    }
  }
`;

export default graphql(CREATE_COLOR_MUTATION, {
  name: "createColorMutation"
})(AddColor);



// WEBPACK FOOTER //
// ./src/components/utilities/AddColor.js